import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingMentor.css";

export default function MentorLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="mentor-landing">

      {/* =====================================================
          NAVBAR
      ====================================================== */}

      <nav className={`mentor-navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="mentor-logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="mentor-logo-img"
          />
        </div>

        <div className={`mentor-nav-links ${menuOpen ? "active" : ""}`}>

          <a
            href="#why"
            onClick={() => setMenuOpen(false)}
          >
            Why Nessefy
          </a>

          <a
            href="#how"
            onClick={() => setMenuOpen(false)}
          >
            How It Works
          </a>

          <a
            href="#community"
            onClick={() => setMenuOpen(false)}
          >
            Community
          </a>

        </div>

        <div className="mentor-nav-actions">

          <button
            className="mentor-nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="mentor-nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`mentor-hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>

      </nav>


      {/* =====================================================
          HERO
      ====================================================== */}

      <section className="mentor-hero">

        <div className="mentor-hero-blob mentor-blob-1"></div>
        <div className="mentor-hero-blob mentor-blob-2"></div>
        <div className="mentor-hero-blob mentor-blob-3"></div>

        <div className="mentor-hero-content">

          <p className="mentor-hero-badge">
            🧭 BUILT FOR PEOPLE WHO HAVE EXPERIENCE TO SHARE
          </p>

          <h1>
            Your Experience
            <br />
            Could Change
            <br />

            <span className="mentor-highlight">
              Someone's Journey.
            </span>
          </h1>

          <p>
            Connect with entrepreneurs, rookies and ambitious builders
            who are looking for guidance, perspective and someone who
            has been there before.
          </p>

          <div className="mentor-hero-buttons">

            <button
              className="mentor-primary-btn"
              onClick={goToRegister}
            >
              🧭 Become a Mentor
              <span className="mentor-button-arrow">
                →
              </span>
            </button>

            <button
              className="mentor-secondary-btn"
              onClick={() => scrollTo("how")}
            >
              See How It Works
            </button>

          </div>

          <div className="mentor-free-points">

            <span>
              <b>✓</b> 100% free to join
            </span>

            <span>
              <b>✓</b> Share your experience
            </span>

            <span>
              <b>✓</b> Help builders grow
            </span>

          </div>

        </div>


        {/* HERO VISUAL */}

        <div className="mentor-hero-card">

          <div className="mentor-floating-card mentor-mini-card-1">
            <h4>🧠 Share Knowledge</h4>
            <p>Turn your experience into someone's advantage</p>
          </div>

          <div className="mentor-post-card">

            <div className="mentor-guidance-visual">

              <div className="mentor-person mentor-person-one">
                👨🏻‍💼
              </div>

              <div className="mentor-person mentor-person-two">
                👩🏻‍💻
              </div>

              <div className="mentor-person mentor-person-three">
                👨🏽‍🚀
              </div>

              <div className="mentor-guidance-line mentor-line-one"></div>
              <div className="mentor-guidance-line mentor-line-two"></div>
              <div className="mentor-guidance-line mentor-line-three"></div>

              <div className="mentor-center">

                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />

              </div>

            </div>

            <div className="mentor-post-copy">

              <h3>
                Guide. Connect. Inspire.
              </h3>

              <p>
                Sometimes the right advice at the right moment
                can change everything.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FREE STRIP
      ====================================================== */}

      <section className="mentor-free-strip">

        <div className="mentor-free-strip-icon">
          ✓
        </div>

        <div>

          <strong>
            Joining Nessefy is completely free.
          </strong>

          <span>
            Create your profile, share your experience and
            connect with people who could benefit from your guidance.
          </span>

        </div>

        <button onClick={goToRegister}>
          Join Free →
        </button>

      </section>


      {/* =====================================================
          SHOWCASE
      ====================================================== */}

      <section className="mentor-showcase">

        <div className="mentor-showcase-content">

          <span className="mentor-showcase-tag">
            SHARE WHAT YOU KNOW
          </span>

          <h2>
            Experience
            <br />
            becomes more
            <br />

            <span className="mentor-showcase-highlight">
              valuable when shared.
            </span>
          </h2>

          <p>
            You have already learned lessons that someone else
            is trying to figure out today. Nessefy gives you a place
            to connect with ambitious people and share the knowledge
            that can help them move faster and make better decisions.
          </p>

          <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>

          <div className="mentor-showcase-benefits">

            <div>

              <span>01</span>

              <strong>Guide</strong>

              <p>
                Help people navigate challenges with practical
                advice from real experience.
              </p>

            </div>

            <div>

              <span>02</span>

              <strong>Connect</strong>

              <p>
                Meet entrepreneurs, rookies and professionals
                who value what you know.
              </p>

            </div>

            <div>

              <span>03</span>

              <strong>Impact</strong>

              <p>
                Help someone turn an idea, challenge or ambition
                into their next step.
              </p>

            </div>

          </div>

        </div>


        {/* PHONE */}

        <div className="mentor-phone-showcase">

          <div className="mentor-floating-ui mentor-ui-top-left">
            🧠 Share Knowledge
          </div>

          <div className="mentor-floating-ui mentor-ui-top-right">
            🌱 Help Someone Grow
          </div>

          <div className="mentor-floating-ui mentor-ui-bottom-left">
            💡 Real Experience
          </div>

          <div className="mentor-floating-ui mentor-ui-bottom-right">
            ✨ Free to Join
          </div>

          <div className="mentor-phone-frame">

            <div className="mentor-phone-notch"></div>

            <div className="mentor-phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="mentor-phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY NESSEFY
      ====================================================== */}

      <section
        id="why"
        className="mentor-features"
      >

        <div className="mentor-features-header">

          <span className="mentor-features-tag">
            WHY BECOME A MENTOR ON NESSEFY?
          </span>

          <h2>
            Your knowledge
            <br />
            can become someone's
            <br />
            <span>next breakthrough.</span>
          </h2>

          <p>
            Great mentors don't just give answers.
            They help people ask better questions, avoid unnecessary
            mistakes and see possibilities they couldn't see before.
          </p>

        </div>


        <div className="mentor-journey-container">

          <div className="mentor-journey-card">

            <div className="mentor-journey-step">
              01
            </div>

            <div className="mentor-journey-icon">
              🧠
            </div>

            <h3>
              Share
            </h3>

            <p>
              Bring your experience, knowledge and lessons
              from your own professional journey.
            </p>

          </div>


          <div className="mentor-journey-arrow">
            →
          </div>


          <div className="mentor-journey-card mentor-featured-journey">

            <div className="mentor-journey-step">
              02
            </div>

            <div className="mentor-journey-icon">
              🤝
            </div>

            <h3>
              Guide
            </h3>

            <p>
              Connect with people who are facing challenges
              where your perspective could make a difference.
            </p>

          </div>


          <div className="mentor-journey-arrow">
            →
          </div>


          <div className="mentor-journey-card">

            <div className="mentor-journey-step">
              03
            </div>

            <div className="mentor-journey-icon">
              🌱
            </div>

            <h3>
              Impact
            </h3>

            <p>
              Help someone take their next step with more
              confidence, clarity and direction.
            </p>

          </div>

        </div>


        <div className="mentor-features-stats">

          <div>
            <h4>FREE</h4>
            <p>Join Nessefy</p>
          </div>

          <div>
            <h4>🧠</h4>
            <p>Share your experience</p>
          </div>

          <div>
            <h4>🌱</h4>
            <p>Help builders grow</p>
          </div>

        </div>

      </section>


      {/* =====================================================
          HOW IT WORKS
      ====================================================== */}

      <section
        id="how"
        className="mentor-about"
      >

        <div className="mentor-about-content">

          <span className="mentor-about-tag">
            HOW IT WORKS
          </span>

          <h2>
            From
            <br />
            “I have experience”
            <br />
            to
            <span className="mentor-how-highlight">
              “Let me help.”
            </span>
          </h2>

          <p>
            You don't need to become a full-time coach or build
            a complicated mentoring program. Start with your profile,
            share what you know and discover people who could benefit
            from your experience.
          </p>


          <div className="mentor-about-points">

            <div>

              <h4>
                01 — Create your profile
              </h4>

              <p>
                Tell the community about your professional background,
                expertise, skills and areas where you can help.
              </p>

            </div>


            <div>

              <h4>
                02 — Discover people to help
              </h4>

              <p>
                Find entrepreneurs, rookies and professionals
                working on ideas and challenges where your experience
                could be valuable.
              </p>

            </div>


            <div>

              <h4>
                03 — Share your perspective
              </h4>

              <p>
                Start conversations, answer questions and help
                people make smarter decisions on their journey.
              </p>

            </div>

          </div>

        </div>


        {/* VISUAL */}

        <div className="mentor-about-visual">

          <div className="mentor-orbit-card mentor-about-card-1">
            Experience
          </div>

          <div className="mentor-orbit-card mentor-about-card-2">
            Guidance
          </div>

          <div className="mentor-orbit-card mentor-about-card-3">
            Strategy
          </div>

          <div className="mentor-orbit-card mentor-about-card-4">
            Growth
          </div>

          <div className="mentor-orbit-card mentor-about-card-5">
            Perspective
          </div>


          <div className="mentor-about-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Guide Someone
            </h3>

            <p>
              Experience • Knowledge • Impact
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          COMMUNITY
      ====================================================== */}

      <section
        id="community"
        className="mentor-community-section"
      >

        <div className="mentor-community-content">

          <span className="mentor-community-tag">
            A COMMUNITY THAT LEARNS TOGETHER
          </span>

          <h2>
            Someone out there
            <br />
            could use what you know.
          </h2>

          <p>
            Nessefy brings together experienced professionals,
            entrepreneurs, founders, rookies, freelancers and
            ambitious builders. Your experience could be exactly
            what someone needs for their next step.
          </p>


          <div className="mentor-community-people">

            <div className="mentor-community-avatar">
              👨🏻‍💼
            </div>

            <div className="mentor-community-avatar">
              👩🏻‍💻
            </div>

            <div className="mentor-community-avatar">
              👨🏽‍🚀
            </div>

            <div className="mentor-community-avatar">
              👩🏽‍💼
            </div>

            <div className="mentor-community-avatar">
              👨🏻‍🎨
            </div>

            <div className="mentor-community-count">
              +
            </div>

          </div>


          <div className="mentor-community-labels">

            <span>Mentors</span>
            <span>Entrepreneurs</span>
            <span>Rookies</span>
            <span>Founders</span>
            <span>Builders</span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ====================================================== */}

      <section className="mentor-contact-section">

        <div className="mentor-contact-content">

          <span className="mentor-contact-tag">
            YOUR EXPERIENCE MATTERS
          </span>

          <h2>
            You don't have to
            <br />
            build everything
            <br />
            yourself.
          </h2>

          <h3>
            Sometimes,
            <br />
            you can help someone
            <span> build.</span>
          </h3>

          <p>
            Join Nessefy for free. Create your profile.
            Share your experience and connect with people
            who are ready to learn, build and grow.
          </p>

          <button
            className="mentor-final-cta-button"
            onClick={goToRegister}
          >
            🧭 Become a Mentor
            <span>— It's Free</span>
          </button>

          <div className="mentor-final-free-line">

            ✓ Free to join

            <span>•</span>

            ✓ No credit card

            <span>•</span>

            ✓ Takes less than 2 minutes

          </div>

        </div>


        {/* FREE CARD */}

        <div className="mentor-contact-card">

          <div className="mentor-free-card-icon">
            🧠
          </div>

          <span>
            YOUR KNOWLEDGE MATTERS.
          </span>

          <h3>
            Help someone
            <br />
            <strong>move forward.</strong>
          </h3>

          <p>
            Create your profile and start
            connecting with people who
            could benefit from your experience.
          </p>

          <button
            onClick={goToRegister}
            className="mentor-free-card-button"
          >
            Create My Free Profile →
          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ====================================================== */}

      <footer className="mentor-footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="mentor-footer-links">

          <span
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>

          <span
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}